import orionDashVideo from "../assets/orion-dashboard.gif"


import orionDashImg from "../assets/orion-dashboard.png"
import maxisIaImg from "../assets/maxis-ia.png"
import naturalisImg from '../assets/naturalis.png';
import naturalisv2Img from '../assets/naturalis-v2.gif';
import clienteFornecedorImg from '../assets/cliente-fornecedor-web-mobile.png';
import clienteFornecedor2Img from '../assets/cliente-info.png';
import pesquisaClinicaImg from '../assets/pesquisa-clinica.png';
import pesquisaClinica2Img from '../assets/pesquisa-clinica-v2.png';
import maxisIa2Img from '../assets/maxis-ia-v2.png';



const allProjects = [
  {
    id: 12,
    name: 'Orion Dashboard',
    moduleCourse: 'Back-end & Front-end',
    img: orionDashImg,
    linkGitHub: 'https://github.com/Emanuel-developer992',
    linkPage: 'https://github.com/Emanuel-developer992',
    linkVideo: orionDashVideo,
    technologies: 'React, Node, Firebase, WhatsApp-API, CSS, HTML5',
    text: 'O projeto de gestão de pedidos tem como objetivo centralizar e automatizar o controle de solicitações de produtos ou serviços dentro de uma empresa. A solução permite que os pedidos sejam cadastrados, acompanhados em tempo real e gerenciados de forma eficiente desde a solicitação até a entrega.'
  },

  {
    id: 11,
    name: 'Maxis I.A',
    moduleCourse: 'Back-end',
    img: maxisIaImg,
    linkGitHub: 'https://github.com/Emanuel-developer992',
    linkPage: 'https://github.com/Emanuel-developer992',
    linkVideo: maxisIa2Img,
    technologies: 'Node, WhatsApp-API, Firebase, SocketIO',
    text: 'Este projeto tem como foco o uso pessoal de inteligência artificial integrada ao WhatsApp, com funcionalidades que facilitam a organização e o gerenciamento das interações no aplicativo. Entre os principais recursos, destaca-se o agendamento de mensagens, permitindo programar envios automáticos em datas e horários específicos — ideal para lembretes, mensagens importantes ou rotinas diárias. Outra funcionalidade central é o resumo inteligente de grupos, que utiliza IA para analisar conversas e gerar um resumo com os principais tópicos discutidos, economizando tempo e evitando a perda de informações relevantes.'
  },
  
  {
    id: 10,
    name: 'Vitrine Virtual',
    moduleCourse: 'Front-end',
    img: naturalisImg,
    linkGitHub: 'https://github.com/Emanuel-developer992',
    linkPage: 'https://github.com/Emanuel-developer992',
    linkVideo: naturalisv2Img,
    technologies: 'React, CSS, HTML5, Tailwind, Firebase, Cloudinary',
    text: 'O projeto da Vitrine Virtual de Afiliados foi criado para facilitar a divulgação e conversão de produtos digitais e físicos de programas de afiliados, como Hotmart, Eduzz, Monetizze, Amazon, entre outros. A plataforma tem como principal objetivo centralizar, organizar e apresentar de forma atrativa os produtos promovidos por um afiliado, com foco em gerar autoridade, confiança e aumentar as taxas de cliques e conversão.'
  },
  
  {
    id: 9,
    name: 'Cliente Fornecedor',
    moduleCourse: 'Back-end & Front-end',
    img: clienteFornecedorImg,
    linkGitHub: 'https://github.com/Emanuel-developer992',
    linkPage: 'https://github.com/Emanuel-developer992',
    linkVideo: clienteFornecedor2Img,
    technologies: 'React, React Native, CSS, HTML5, Firebase, AWS, Node',
    text: 'Este projeto propôs uma solução inovadora para o mercado de importação e exportação, oferecendo uma aplicação web e mobile voltada à conexão estratégica entre empresas, fornecedores e compradores de mais de 100 países.A plataforma centraliza uma base global de contatos comerciais, permitindo ao usuário acessar uma lista dinâmica e atualizada de potenciais clientes e fornecedores, com recursos avançados de filtros e segmentação, como país, setor, volume de negociação, certificações, sanções, entre outros.'
  },
  
  {
    id: 8,
    name: 'Pesquisa Clínica - ERP',
    moduleCourse: 'Back-end, Front-end & Fluxo de Processo',
    img: pesquisaClinicaImg,
    linkGitHub: 'https://github.com/Emanuel-developer992',
    linkPage: 'https://github.com/Emanuel-developer992',
    linkVideo: pesquisaClinica2Img,
    technologies: 'JavaScript, HTML5, CSS, AJAX, jQuery, Bootstrap, ECM Engine, ECM Workflow',
    text: 'O projeto consistiu no desenvolvimento de um sistema ERP sob medida, utilizando a plataforma TOTVS Fluig, para atender às demandas específicas de uma empresa de pesquisa clínica. A solução foi pensada para integrar diversos setores da organização em uma única plataforma digital, promovendo eficiência operacional, rastreabilidade de dados e conformidade regulatória.'
  },

];


export default allProjects;